"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_router_dom_1 = require("react-router-dom");
const EmailOutlined_1 = __importDefault(require("@mui/icons-material/EmailOutlined"));
const LocalPhoneOutlined_1 = __importDefault(require("@mui/icons-material/LocalPhoneOutlined"));
const PinDropOutlined_1 = __importDefault(require("@mui/icons-material/PinDropOutlined"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const helpers_1 = require("../../../common/helpers/helpers");
;
const isMobile = () => helpers_1.Helpers.isMobile.Android() || helpers_1.Helpers.isMobile.iOS();
const CircleCTA = styled_components_1.default.div `
  display: flex;
  position: relative;
  justify-content: start;
  flex-wrap: wrap;
  flex-direction: column;
  cursor: pointer;
  align-items: center;
`;
const Icon = styled_components_1.default.div `
  width: 40px;
  height: 40px;
  text-align: center;
  background-color: ${(props) => `${props.theme.palette.mainAppColor.light}`};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 700px) {
    width: 44px;
    height: 44px;
  }
`;
const Text = styled_components_1.default.div `
  padding-top: 5px;
  text-align: center;
`;
const CallToActionItemNew = (props) => {
    const { onClick, text, activeItem, icon, destination, pushToDestination, history, location, } = props;
    const call = (number) => {
        document.location.href = `tel:${number}`;
    };
    const email = (address) => {
        window.location.href = `mailto:?to=${address}`;
    };
    const goToDestination = () => {
        if (destination === "call" && isMobile()) {
            call(activeItem.content.phone);
            return;
        }
        if (destination === "email" && isMobile()) {
            email(activeItem.content.email);
            return;
        }
        if (pushToDestination) {
            history.push({
                pathname: `${location.pathname}/${destination}`,
                search: location.search,
            });
            return;
        }
        if (onClick) {
            onClick();
        }
    };
    const renderGraphic = () => {
        if (icon === "email") {
            return react_1.default.createElement(EmailOutlined_1.default, { htmlColor: "black" });
        }
        if (icon === "call") {
            return react_1.default.createElement(LocalPhoneOutlined_1.default, { htmlColor: "black" });
        }
        return react_1.default.createElement(PinDropOutlined_1.default, { htmlColor: "black" });
    };
    return (react_1.default.createElement(CircleCTA, { onClick: goToDestination },
        react_1.default.createElement(Icon, { className: "call-to-action-icon" }, renderGraphic()),
        react_1.default.createElement(Text, { className: "call-to-action-text" },
            react_1.default.createElement(Typography_1.default, { variant: "caption" }, text))));
};
exports.default = (0, react_router_dom_1.withRouter)(CallToActionItemNew);
